import { render, staticRenderFns } from "./btYhubDataDetail.vue?vue&type=template&id=22addaf8&scoped=true"
import script from "./btYhubDataDetail.vue?vue&type=script&lang=js"
export * from "./btYhubDataDetail.vue?vue&type=script&lang=js"
import style0 from "./btYhubDataDetail.vue?vue&type=style&index=0&id=22addaf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22addaf8",
  null
  
)

export default component.exports